import { Modal } from "components/UI/Modal";
import { PACKAGE_TYPE } from "constants/packageOptions.constants";
import { useAppSelector } from "hooks/useAppSelector";
import { selectCargoRowById } from "store";
import { PackageSettingsModalProps } from "./PackageSettings.types";
import { BarrelsContent } from "./ModalContent/BarrelsContent";
import { BigBagsContent } from "./ModalContent/BigBagsContent";
import { BoxContent } from "./ModalContent/BoxContent";
import { PipesContent } from "./ModalContent/PipesContent";
import { RollsContent } from "./ModalContent/RollsContent";
import { SacksContent } from "./ModalContent/SacksContent";
import s from "./PackageSettings.module.scss";

export const PackageSettingsModal = ({ groupId, rowId, isOpen, onClose }: PackageSettingsModalProps) => {
  const row = useAppSelector(selectCargoRowById(groupId, rowId));
  const settings = row?.packageSettings;

  const renderContent = () => {
    if (!settings) return null;

    switch (settings.type) {
      case PACKAGE_TYPE.BOX:
        return <BoxContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      case PACKAGE_TYPE.BIG_BAGS:
        return <BigBagsContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      case PACKAGE_TYPE.BARRELS:
        return <BarrelsContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      case PACKAGE_TYPE.SACKS:
        return <SacksContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      case PACKAGE_TYPE.ROLLS:
        return <RollsContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      case PACKAGE_TYPE.PIPES:
        return <PipesContent settings={settings} groupId={groupId} rowId={rowId} onClose={onClose} />;

      default:
        return null;
    }
  };

  if (!renderContent()) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} modalClassname={s.modal}>
      {renderContent()}
    </Modal>
  );
};
